import { __extends } from "tslib";
import { StartEntitiesDetectionJobRequest, StartEntitiesDetectionJobResponse } from "../models/index";
import { deserializeAws_json1_1StartEntitiesDetectionJobCommand, serializeAws_json1_1StartEntitiesDetectionJobCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartEntitiesDetectionJobCommand = /** @class */ (function (_super) {
    __extends(StartEntitiesDetectionJobCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartEntitiesDetectionJobCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartEntitiesDetectionJobCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartEntitiesDetectionJobRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartEntitiesDetectionJobResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartEntitiesDetectionJobCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartEntitiesDetectionJobCommand(input, context);
    };
    StartEntitiesDetectionJobCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartEntitiesDetectionJobCommand(output, context);
    };
    return StartEntitiesDetectionJobCommand;
}($Command));
export { StartEntitiesDetectionJobCommand };
//# sourceMappingURL=StartEntitiesDetectionJobCommand.js.map